(function($){
	$(document).ready(()=> {
		$('.js-content-block-faq-list').each((index, list)=> {
			const $items = $(list).find('.content-block-faq-list-item');

			$items.length && $items.each((index, currentListItem)=> {
				const $trigger = $(currentListItem).find('.content-block-faq-list-item__trigger');

				$trigger.length && $trigger.on('click', ()=> {
					$items.each((index, listItem)=> {
						$(listItem).removeClass('content-block-faq-list-item--open');
					})

					$(currentListItem).addClass('content-block-faq-list-item--open');
				});
			});
		});
	});
})(jQuery)